import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress ResizeObserver loop errors globally
// These are benign warnings that don't affect functionality
const resizeObserverErr = (e) => {
  if (e.message?.includes('ResizeObserver loop') || 
      e.message?.includes('ResizeObserver loop completed with undelivered notifications')) {
    e.stopImmediatePropagation();
    return;
  }
};
window.addEventListener('error', resizeObserverErr);
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason?.message?.includes('ResizeObserver')) {
    e.preventDefault();
  }
});

// Also patch the ResizeObserver to prevent loop errors
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      window.requestAnimationFrame(() => {
        try {
          callback(entries, observer);
        } catch (e) {
          // Silently handle errors
        }
      });
    });
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
